<script setup lang="ts">
import { computed, onUpdated } from 'vue';
import { useWarningOverlay } from '@/store/overlays/warning-overlay';
import { useDisplay } from 'vuetify';
import { useUserStore } from '@/store/user';
import { useI18n } from 'vue-i18n';

const store = useWarningOverlay();
const { name } = useDisplay();
const user = useUserStore();
const { t } = useI18n();

const custom_text_width = computed((): string => {
  switch (name.value) {
    case "xs":
      return "w-100";
    case "sm":
      return "w-100";
    default:
      return "w-50";
  }
});

onUpdated(() => {
  if (user.is_guest) {
    const text = t("text");
    store.set_text(text);
  }
});

</script>

<template>
  <v-overlay
    v-model="store.is_visible"
    no-click-animation
    absolute
    persistent
    class="align-center justify-center"
    style="background-color: rgba(243, 116, 3, 0.8); z-index: 1200;"
  >
    <v-container fluid>
      <v-col class="align-center text-wrap">
        <v-row class="justify-center">
          <span
            :class="`text-center text-white text-body-1 font-weight-medium ${custom_text_width}`"
            style="white-space: pre-line;"
          >
            {{ store.text }}
          </span>
        </v-row>
      </v-col>
    </v-container>
  </v-overlay>
</template>

<style scoped lang="scss">
</style>

<i18n lang="yaml">
en:
  text: "There could be some problem with the chargepoint.\n50€ was taken to start the charge; however, no amount is credited until the end of the charge. Consequently, the money taken will be refunded to you within a week."
it:
  text: "Potrebbero esserci stati dei problemi con la colonnina.\nSono stati pre-autorizzati 50€ per avviare la carica; tuttavia l'importo non viene accreditato fino al termine della ricarica. Il denaro prelevato verrà rimborsato entro una settimana."
de:
  text: "Es könnte ein Problem mit der Stromzapfsäule geben.\n50€ wurden für den Beginn des Ladevorgangs abgebucht; Es wird jedoch kein Betrag bis zum Ende des Ladevorgangs gutgeschrieben. Daher wird Ihnen das entnommene Geld innerhalb einer Woche zurückerstattet."
fr:
  text: "Il pourrait y avoir un problème avec le point de charge.\n50€ ont été prélevés pour démarrer la charge ; Cependant, aucun montant n'est crédité jusqu'à la fin de la charge. Par conséquent, l'argent prélevé vous sera remboursé dans un délai d'une semaine."
nl:
  text: "Er kan een probleem zijn met het oplaadpunt.\nEr is € 50 afgeschreven om het opladen te starten; Er is echter geen bedrag bijgeschreven tot het einde van de oplaadbeurt. Daarom wordt het geld binnen een week teruggestort."
</i18n>

<!-- vim: softtabstop=2:shiftwidth=2
-->
